import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/system'
import {useStyles, useContentSections, useContentSections2, useContentSections3, useContentSections4} from '../styles/home';
import { TfiAngleLeft } from "react-icons/tfi";
import { TfiAngleRight } from "react-icons/tfi";
import { Swiper, SwiperClass, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import SwiperCore, {  } from 'swiper';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Grid } from '@mui/material';
import { MdMenuBook } from "react-icons/md";
import Footer from '../components/footer/Footer';
import * as ROUTES from '../constants/routes'
import Popup from '../components/appbar/Popup';




interface Props {
    children: any;
}

const handleSliderNext =(swiper: SwiperClass)=>{
    // Handle slider
    swiper.slideNext()
}


const handleSliderPrev =(swiper: SwiperClass)=>{
    // Handle slider
    swiper.slidePrev()
}

const SwiperButtonNext: React.FC<Props> = ({ children }) => {
    const swiper = useSwiper();
    return <button onClick={()=> handleSliderNext(swiper)}>{children}</button>;
};
const SwiperButtonPrev: React.FC<Props> = ({ children }) => {
    const swiper = useSwiper();
    return <button onClick={()=> handleSliderPrev(swiper)}>{children}</button>;
};


SwiperCore.use([Autoplay])

const HomeContainer: React.FC = () => {
    const classes = useStyles()
    const classes2 = useContentSections()
    const classes3 = useContentSections2()
    const classes4 = useContentSections3()
    const classes5 = useContentSections4()

    const swiperRef = useRef<any>(null)
    var [currentDotState, setCurrentDotState] = useState<any>(1)

    const Hero = styled('section')(({ theme }) => ({
        position: 'relative',
        width: '100%',
        height: '100vh',
        visibility: 'visible',
        overflow: 'hidden',
        display: 'block',      
    
        [theme.breakpoints.down('md')]: {
            height: '480px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '537px',
        },
    }));
   

    const HeroInner = styled('section')(({ theme }) => ({
        height: 'auto',
        transform: 'translateY(0px)',
        position: 'fixed',
        top: 0,
        left: 0
,        width: '100%',
        visibility: 'visible',
    
        [theme.breakpoints.down('md')]: {
            position: 'static',
        },
    
    }));
 

    const FirstContent = styled('section')(({ theme }) => ({
        margin: 0,
        background: 'linear-gradient(90deg, white 50%, #eee 50%)',
        position: 'relative',
        overflow: 'hidden',

        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    }));
    const FirstContentResponsive = styled('section')(({ theme }) => ({
        display: 'none',
        [theme.breakpoints.down('md')]: {
            display: 'block',
            margin: '0',
            backgroundColor: '#fff'
        },
    }));
    const FirstContentResponsiveInner = styled('section')(({ theme }) => ({
        padding: '50px 15px',
        position: 'relative',
        margin: '0 auto',
    }));

    useEffect(() => {
        const sectionEl = document.getElementById("second-content")
        const handleScroll = () => {

            if(sectionEl){
                sectionEl.style.backgroundPositionY = `-${window.scrollY * 0.15}px`
            }
            
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
    const SecondContent = styled('section')(({ theme }) => ({
        backgroundImage: 'url(/imgs/backgrond.png)',
        backgroundSize: '120% 120%',
        padding: '80px 0px',
        borderBottom: 'none',
        backgroundColor: 'transparent',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        zIndex: '10',
        transition: 'all 0.17s linear !important',
        
        [theme.breakpoints.down('lg')]: {
            backgroundPositionY: 'center !important',
            backgroundSize: 'cover',
        },
    }));

    const ThirdContent = styled('section')(({ theme }) => ({
        padding: '50px 0',
        background: '#fff',
        color: '#000',
        position: 'relative',
        overflow: 'hidden',
    }));

    useEffect(() => {
        const sectionEl = document.getElementById("fouth-content")
        const sectionRect = sectionEl?.getBoundingClientRect().top
        const handleScroll = () => {
            if(sectionEl && sectionRect){
                sectionEl.style.backgroundPositionY = `${(window.scrollY - sectionRect) * 0.15}px`
            }
            
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
      }, [currentDotState]);
    const FouthContent = styled('section')(({ theme }) => ({
        backgroundImage: 'url(/imgs/background2.jpg)',
        backgroundSize: '120% 120%',
        padding: '80px 0px',
        borderBottom: 'none',
        backgroundColor: '#120523',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        zIndex: '10',
        transition: 'all 0.17s linear !important',
        
        [theme.breakpoints.down('lg')]: {
            backgroundPositionY: 'center !important',
            backgroundSize: 'cover',
        },
    }));

    const FifthContent = styled('section')(({ theme }) => ({
        position: 'relative',
        overflow: 'hidden',
        background: '#fff',
    }));

    const SithContent = styled('section')(({ theme }) => ({
        background: '#eaeaea',
        padding: '20px 0 !important',
        position: 'relative',
        textAlign: 'center',
        marginTop: '-50px !important',
        zIndex: '220'
    }));
    const SeventhContent = styled('section')(({ theme }) => ({
        background: '#422861',
        padding: '20px 0 !important',
        position: 'relative',
        marginTop: '-50px !important',
    }));


    useEffect(()=>{

        const card = document.querySelector('.card');
        
        if(card){
            card.addEventListener('touchstart', function() {
                card.classList.toggle('flip');
            });
        
            card.addEventListener('touchend', function() {
                card.classList.toggle('flip');
            });
        }
    })



    const handleSwiperChange = (e: any) =>{
        // Handle counter Stuff
            

        document.getElementById('counter-current-slider')!.innerHTML = `${e.activeIndex + 1}`

        var number = e.activeIndex + 1
        if(number === 3){
            document.getElementById('hero-slider-animation-3')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-3A')?.classList.add('fadeup-animation')
        }else{
            document.getElementById('hero-slider-animation-3')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-3A')?.classList.remove('fadeup-animation')
        }
    
        if(number === 4){
            document.getElementById('hero-slider-animation-4A')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-4B')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-4C')?.classList.add('fadeup-animation')
        }else{
            document.getElementById('hero-slider-animation-4A')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-4B')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-4C')?.classList.remove('fadeup-animation')
        }
    
        if(number === 5){
            document.getElementById('hero-slider-animation-5A')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-5B')?.classList.add('fadeup-animation')
        }else{
            document.getElementById('hero-slider-animation-5A')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-5B')?.classList.remove('fadeup-animation')
        }
    
        if(number === 6){
            document.getElementById('hero-slider-animation-6A')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-6B')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-6C')?.classList.add('fadeup-animation')
        }else{
            document.getElementById('hero-slider-animation-6A')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-6B')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-6C')?.classList.remove('fadeup-animation')
        }
    
        if(number === 7){
            document.getElementById('hero-slider-animation-7A')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-7B')?.classList.add('fadeup-animation')
            document.getElementById('hero-slider-animation-7C')?.classList.add('fadeup-animation')
        }else{
            document.getElementById('hero-slider-animation-7A')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-7B')?.classList.remove('fadeup-animation')
            document.getElementById('hero-slider-animation-7C')?.classList.remove('fadeup-animation')
        }


    }

    
    const [needed, setNeeded] = useState<boolean>(false)
    const [name, setName] = useState<string>('')
    const handleStarLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()
        
        setName("home-star-atm")
        setNeeded(true)
    }
    const handleNadaLink = (event: React.MouseEvent<HTMLAnchorElement>) =>{
        event.preventDefault()
        
        setName("home-nada-link")
        setNeeded(true)
    }
    const handleTruState = (event: React.MouseEvent<HTMLAnchorElement>) =>{
        event.preventDefault()
        
        setName("home-tru-state")
        setNeeded(true)
    }

  return (
    <>
        <main>
            <Hero>
                <HeroInner>
                    <Swiper 
                        id='hero-section'
                        modules={[Navigation, Pagination, Scrollbar, A11y]} 
                        slidesPerView={1}
                        ref={swiperRef}
                        onSlideChange={handleSwiperChange}
                        pagination={{ clickable: true }}
                        autoplay={{
                            delay: 6000, // Delay between slides in milliseconds (default: 3000)
                            disableOnInteraction: true, // Pause autoplay on interaction (default: true)
                        }}>
    
    
                        <SwiperButtonPrev>
                            <div className={classes.sliderButtonLeft}>
                                <TfiAngleLeft  className={classes.buttonIcon}/>
                            </div>
                        </SwiperButtonPrev>
                        <SwiperButtonNext>
                            <div className={classes.sliderButtonRight}>
                                <TfiAngleRight  className={classes.buttonIcon}/>
                            </div>
                        </SwiperButtonNext>
    
                       
                        <div id='counter'>
                            <div id='counter-current-slider' className={classes.currentSideNumber}>1</div>
                            <span className={classes.sideNumberSpan}>/</span>
                            <div className={classes.sideNumber}>7</div>
                        </div>
    
    
    
    
                        <SwiperSlide style={{marginTop: '100px'}}>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <img src="/imgs/fin1.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'contain'}}/>
                            </div>
                        </SwiperSlide>
    
                        <SwiperSlide>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <img src="/imgs/fin2.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'contain'}}/>
                            </div>
                        </SwiperSlide>
    
                        <SwiperSlide>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <div className={classes.textContainer}>
                                    <div className={classes.textArea1}>
                                        <h2 id='hero-slider-animation-3' className={classes.textAreaH2Animate}>STUDENT LOANS</h2>
                                        <p id='hero-slider-animation-3A' className={classes.textAreaPAnimate}>Get the Financial Support You Need for College</p>
                                        <div className={classes.slideButton}>
                                            <a href="https://www.iowastudentloan.org/for-lenders/available-loan-options-cc.aspx?ref=cc1104&cid=cc1104&utm_source=cc&utm_medium=referral&utm_campaign=plps&utm_content=cc1104" target='_blank' className={classes.textAreaPBtn}>Click Here</a>
                                        </div>
                                    </div>
                                </div>
                                <img src="/imgs/fin3.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'cover',}}/>
                            </div>
                        </SwiperSlide>
    
                        <SwiperSlide>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <div className={classes.textContainer}>
                                    <div className={classes.textArea2}>
                                        <h2 id='hero-slider-animation-4A' className={classes.textAreaH2Animate} style={{color: 'rgb(66, 36, 99)'}}>Does your family have a safety net if the unexpected hits?</h2>
                                        <p id='hero-slider-animation-4B' className={classes.textAreaPAnimate}>Protect your loan balance or loan payments today!</p>
                                        <div id='hero-slider-animation-4C' className={classes.slideButtonAnimate}>
                                            <a href="/files/debt_protection_lifeplus.pdf" target='_blank' className={classes.textAreaPBtn}>Click Here</a>
                                        </div>
                                    </div>
                                </div>
                                <img src="/imgs/fin4.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'cover'}}/>
                            </div>
                        </SwiperSlide>
    
                        <SwiperSlide>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <div className={classes.textContainer}>
                                    <div className={classes.textArea3}>
                                        <h2 id='hero-slider-animation-5A' className={classes.textAreaH2Animate} style={{color: '#eee', marginBottom: '20px'}}>We're Here To Help You GET THE CAR YOU WANT</h2>
                                        <div id='hero-slider-animation-5B' className={classes.slideButtonAnimate}>
                                            <a href={ROUTES.LOAN_APPLICATION} target='_blank' className={classes.textAreaPBtn}>Get Pre-Approved Today</a>
                                        </div>
                                    </div>
                                </div>
                                <img src="/imgs/fin5.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'cover'}}/>
                            </div>
                        </SwiperSlide>
    
                        <SwiperSlide>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <div className={classes.textContainer}>
                                    <div className={classes.textArea4}>
                                        <h2 id='hero-slider-animation-6A' className={classes.textAreaH2Animate} style={{color: '#eee'}}>Mechanical Breakdown Protection</h2>
                                        <p id='hero-slider-animation-6B' className={classes.textAreaPAnimate}>Protect your loan balance or loan payments today!</p>
                                        <div id='hero-slider-animation-6C' className={classes.slideButtonAnimate}>
                                            <a href={ROUTES.PROMOTION} className={classes.textAreaPBtn}>More Details Here</a>
                                        </div>
                                    </div>
                                </div>
                                <img src="/imgs/fin6.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'cover'}}/>
                            </div>
                        </SwiperSlide>
    
                        <SwiperSlide>
                            <div className="grabbing-grab" style={{position: 'relative', width: '100%', height: '100%'}}>
                                <div className={classes.textContainer} style={{maxWidth: '100%'}}>
                                    <div className={classes.textArea5}>
                                        <h2 id='hero-slider-animation-7A' className={classes.textAreaH2Animate} style={{color: 'rgb(34, 34, 34)'}}>Need Cash Fast?</h2>
                                        <p id='hero-slider-animation-7B' className={classes.textAreaPAnimate} style={{color: 'rgb(34, 34, 34)', marginBottom: '40px'}}>Check Out Our Cash N' Dash Payday Alternative Loan</p>
                                        <div id='hero-slider-animation-7C' className={classes.slideButtonAnimate}>
                                            <a href={ROUTES.PROMOTION} className={classes.textAreaPBtn}>More Details Here</a>
                                        </div>
                                    </div>
                                </div>
                                <img src="/imgs/fin7.jpg" alt="" style={{verticalAlign: "middle", width: '100%', height: '100%', objectFit: 'cover'}}/>
                            </div>
                        </SwiperSlide>
                    </Swiper>
    
                </HeroInner>
            </Hero>
    
            <FirstContent>
                <div className={classes2.inner}>
                    <div className={classes2.inner2}>
                        <div className={classes2.rowHalf}>
                            <a href={ROUTES.LOAN_APPLICATION} className={classes2.linkButtonSmall}>Apply For a Loan</a>
                            <div className={classes2.lostNumberSmall}>
                                Lost/Stolen Debit Cards:
                                <span style={{fontFamily: '"Raleway", sans-serif', marginLeft: '1rem'}}>1-800-523-4175</span>
                            </div>
                            <div className={classes2.lostNumberSecondSmall}>
                                Lost/Stolen VISA Credit Cards:
                                <span style={{fontFamily: '"Raleway", sans-serif', marginLeft: '1rem'}}>1-800-322-8472</span>
                            </div>
                        </div>

                        <h3 className={classes2.firstContentH3}>ATM LOCATORS</h3>
                
                        <div className={classes2.rowHalfLast}>
                            <a onClick={handleStarLink} href="http://www.star.com/?go=atmLocator.start" target='_blank' className={classes2.rowHalfLastLink}>
                                <img src="/imgs/star.gif" alt="Star ATM" className={classes2.rowHalfLastImg}  />
                            </a>
                        </div>
                    </div>
                </div>
            </FirstContent>
            <FirstContentResponsive>
                <FirstContentResponsiveInner>
                    <div className={classes2.firstContentResponsive}>
                        <div className={classes2.halfSmall}>
                            <a href="" className={classes2.linkButtonSmall}>Apply For a Loan</a>
                            <div className={classes2.lostNumberSmall}>
                                Lost/Stolen Debit Cards:
                                <span style={{fontFamily: '"Raleway", sans-serif', marginLeft: '0.5rem'}}>1-800-523-4175</span>
                            </div>
                            <div className={classes2.lostNumberSecondSmall}>
                                Lost/Stolen VISA Credit Cards:
                                <span style={{fontFamily: '"Raleway", sans-serif', marginLeft: '0.5rem'}}>1-800-322-8472</span>
                            </div>
                        </div>

                        <h3 className={classes2.firstContentH3Small}>ATM LOCATORS</h3>

                        <div className={classes2.rowHalfLastSmall}>
                            <a href="" className={classes2.rowHalfLastLink}>
                                <img src="/imgs/star.gif" alt="Star ATM" className={classes2.rowHalfLastImg}  />
                            </a>
                        </div>
                    </div>
                </FirstContentResponsiveInner>
            </FirstContentResponsive>

            <SecondContent id='second-content'>
                <div className={classes3.secondContent1}>
                    <div className={classes3.sectionTitleHolder}>
                        <h2 className={classes3.sectionTitle}>Featured Rates</h2>
                        <a href={ROUTES.LOAN_APPLICATION} className={classes3.sectionTitleLink}>Apply Now</a>
                    </div>
                </div>
                <div className={classes3.secondContent1} style={{marginBottom: '1.5rem'}}>
                    <Grid container style={{alignContent: 'center', justifyContent: 'center'}}>
                        <Grid item xs={11} sm={9} md={6}>
                            <div className={classes3.secondSecCard}>
                                <div className={classes3.secondSecCardImg} style={{backgroundImage: 'url(/imgs/carkey.jpg)'}}></div>
                                <div className={classes3.secondSecText}>
                                    <p className={classes3.secondSecText1}>NEW AUTO</p>
                                    <p className={classes3.secondSecText2}>AS LOW AS</p>
                                    <h2 className={classes3.secondSecText3}>5.50% <span className={classes3.secondSecText4}>APR*</span></h2>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={11} sm={9} md={6}>
                            <div className={classes3.secondSecCard}>
                                <div className={classes3.secondSecCardImg} style={{backgroundImage: 'url(/imgs/card.jpg)'}}></div>
                                <div className={classes3.secondSecText}>
                                    <p className={classes3.secondSecText1}>VISA PREFERRED</p>
                                    <p className={classes3.secondSecText2}>AS LOW AS</p>
                                    <h2 className={classes3.secondSecText3}>13.00% <span className={classes3.secondSecText4}>APR*</span></h2>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={11} sm={9} md={6}>
                            <div className={classes3.secondSecCard}>
                                <div className={classes3.secondSecCardImg} style={{backgroundImage: 'url(/imgs/calculator.jpg)'}}></div>
                                <div className={classes3.secondSecText}>
                                    <p className={classes3.secondSecText1}>USED AUTO</p>
                                    <p className={classes3.secondSecText2}>AS LOW AS</p>
                                    <h2 className={classes3.secondSecText3}>6.00% <span className={classes3.secondSecText4}>APR*</span></h2>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={11} sm={9} md={6}>
                            <div className={classes3.secondSecCard}>
                                <div className={classes3.secondSecCardImg} style={{backgroundImage: 'url(/imgs/home.jpg)'}}></div>
                                <div className={classes3.secondSecText}>
                                    <p className={classes3.secondSecText1}>HOME EQUITY</p>
                                    <p className={classes3.secondSecText2}>AS LOW AS</p>
                                    <h2 className={classes3.secondSecText3}>6.75% <span className={classes3.secondSecText4}>APR*</span></h2>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    
                </div>
                <div className={classes3.secondContent1}>
                    <span className={classes3.secondContentLastText}>*APR - Annual Percentage Rate. Rates Subject To Change Without Notice.</span>
                </div>
            </SecondContent>

            <ThirdContent>
                <div className={classes4.thirdInner}>
                    <div className={classes3.secondContent1}>
                        <h2 className={classes4.sectionTitle}>Our Services</h2>
                    </div>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <div className="flip-card">
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">

                                        <div className={classes4.sectionCard}>
                                            <div className={classes4.sectionCardIcon}>
                                                <i className="fa fa-calculator"></i>
                                            </div>
                                            <h3 className={classes4.setion4H3}>Finatial Calculators</h3>
                                        </div>

                                    </div>

                                    <div className="flip-card-back">
                                        <div className={classes4.sectionBackCard}>
                                            <h3 className={classes4.setionBack4H3}>Finatial Calculators</h3>
                                            <p className={classes4.setionBack4P}>Use our tools to help make educated finatial decisions</p>
                                            <a href={ROUTES.CALCULATOR} className={classes4.sectionCardLink}>Apply Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <div className="flip-card">
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">

                                        <div className={classes4.sectionCard}>
                                            <div className={classes4.sectionCardIcon}>
                                                <i className="fa fa-usd card-icon"></i>
                                            </div>
                                            <h3 className={classes4.setion4H3}>ATM Locator</h3>
                                        </div>

                                    </div>

                                    <div className="flip-card-back">
                                        <div className={classes4.sectionBackCard}>
                                            <h3 className={classes4.setionBack4H3}>ATM Locator</h3>
                                            <p className={classes4.setionBack4P}>Find an ATM wherever you go</p>
                                            <a href={ROUTES.ATM_LOCATOR} className={classes4.sectionCardLink}>Find An ATM</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <div className="flip-card">
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">

                                        <div className={classes4.sectionCard}>
                                            <div className={classes4.sectionCardIcon}>
                                                <MdMenuBook />
                                            </div>
                                            <h3 className={classes4.setion4H3}>Reorder Checks</h3>
                                        </div>

                                    </div>

                                    <div className="flip-card-back">
                                        <div className={classes4.sectionBackCard}>
                                            <h3 className={classes4.setionBack4H3}>Reorder Checks</h3>
                                            <p className={classes4.setionBack4P}>Reordering online is easier than ever</p>
                                            <a href={ROUTES.CHECKING_ACCOUNTS} className={classes4.sectionCardLink}>Register Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <div className="flip-card">
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">

                                        <div className={classes4.sectionCard}>
                                            <div className={classes4.sectionCardIcon}>
                                                <i className="fa fa-car"></i>
                                            </div>
                                            <h3 className={classes4.setion4H3}>J.D. Power (formerly NADA)</h3>
                                        </div>

                                    </div>

                                    <div className="flip-card-back">
                                        <div className={classes4.sectionBackCard}>
                                            <h3 className={classes4.setionBack4H3}>J.D. Power (formerly NADA)</h3>
                                            <p className={classes4.setionBack4P}>Find the car you need at an affordable price</p>
                                            <a onClick={handleNadaLink} href="http://www.nadaguides.com/" target='_blank' className={classes4.sectionCardLink}>Start Searching</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </ThirdContent>

            <FouthContent id='fouth-content'>
                <div className={classes4.thirdInner}>
                    <div className={classes3.secondContent1}>
                        <h2 className={classes5.sectionTitle}>Our Partners</h2>

                        <div>
                            <Grid container>
                                <Grid item xs={12} md={6} style={{marginBottom: '1rem'}}>
                                    <a target='_blank' href="https://www.iowastudentloan.org/for-lenders/available-loan-options-cc.aspx?ref=cc1104&cid=cc1104&utm_source=cc&utm_medium=referral&utm_campaign=plps&utm_content=cc1104">
                                        <img src="/imgs/graduation.jpg" alt="" className={classes5.img}/>
                                    </a>
                                </Grid>

                                <Grid item xs={12} md={6} style={{marginBottom: '1rem'}}>
                                    <a onClick={handleTruState} href="https://lnkmgr.trustage.com/2b5072bf-aa4a-2d16-31c6-b08fd058c213" target='_blank'>
                                        <img src="/imgs/camp.jpg" alt="" className={classes5.img} />
                                    </a>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </FouthContent>

            <FifthContent>
                <div className={classes5.firstFifthCon}>
                    <div className={classes5.firstFifthConInner}>
                        <Grid container className={classes5.container}>
                            <Grid item xs={12} md={6} className={classes5.imgHalf} data-aos="fade-left" data-aos-delay="300" data-aos-duration="500">
                                <div className={classes5.iconSection}>
                                    <div className={classes5.iconSectionInner}>
                                        <h2 className={classes5.iconSectionInnerH2}><div className={classes5.iconSectionInnerSpan}><span>Join Us </span> <i className="fa fa-users"><div className={classes5.enterSearch}>Enter Search</div></i></div>
                                        </h2>
                                    </div>
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6} className={classes5.textHalf}>
                                <div className={classes5.textHolder}>
                                    <p className={classes5.text}>Elite Community Credit Union is <strong>committed</strong> to meet our members' financial needs and assist them in attaining their financial goals. We strive to provide the best services possible while maintaining long-term financial stability.</p>
                                    <a href={ROUTES.BECOME_A_MEMBER}><button className={classes5.button}>Become a member</button></a>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes5.firstFifthConInner}>
                        <Grid container>
                            <Grid item xs={12} md={6} className={classes5.textHalf}>
                                <div className={classes5.textHolder}>
                                    <p className={classes5.text}>Elite Community Credit Union is <strong>committed</strong> to meet our members' financial needs and assist them in attaining their financial goals. We strive to provide the best services possible while maintaining long-term financial stability.</p>
                                    <a href={ROUTES.BECOME_A_MEMBER}><button className={classes5.button}>Become a member</button></a>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6} className={classes5.imgHalf2} data-aos="fade-right" data-aos-delay="300" data-aos-duration="500">
                                <div className={classes5.iconSection}>
                                    <div className={classes5.iconSectionInner}>
                                        <h2 className={classes5.iconSectionInnerH2}><div className={classes5.iconSectionInnerSpan}><span>Save More </span> <i className="fa fa-calculator"><div className={classes5.enterSearch}>Enter Search</div></i></div>
                                        </h2>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </FifthContent>

            <SithContent>
                <div className={classes3.secondContent1}>
                    <h3 className={classes5.diffH3}>STATE OF ILLINOIS COMMUNITY REINVESTMENT NOTICE</h3>
                    <p className={classes5.diffP}>The Department of Financial and Professional Regulation (Department) evaluates our performance in meeting the financial services needs of this community, including the needs of low-income to moderate-income households. The Department takes this evaluation into account when deciding on certain applications submitted by us for approval by the Department. Your involvement is encouraged. You may obtain a copy of our evaluation once the Department completes our first evaluation. You may also submit signed, written comments about our performance in meeting community financial services needs to the Department. We will update this notice when our first evaluation has been issued.</p>
                </div>
            </SithContent>

            <Footer />
        </main>
        <Popup needed={needed} setNeeded={setNeeded} name={name} setName={setName}/>
    </>
  )
}

export default HomeContainer
